import axios from 'axios';

export const baseURL = '/erp/rest/s1/';
export const baseWebSocketURL = 'erp/iamws';

export const Api = axios.create({
	baseURL: baseURL
});
